import { SelectionCard as CXSelectionCard } from '@sanlamcx/react-ui-next-selection-cards';

type SelectionCard = typeof CXSelectionCard;

export const SelectionCard: SelectionCard = CXSelectionCard;
